export const bookmarkList = {
  title: "お気に入り",
  empty: "お気に入りがまだありません",
} as const;
